var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSimpleLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.059,
    height: 18.059,
    viewBox: "0 0 18.059 18.059",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-linkedin",
    "data-name": "Icon simple-linkedin",
    d: "M15.385,15.389H12.711V11.2c0-1-.02-2.285-1.394-2.285C9.923,8.913,9.71,10,9.71,11.125v4.264H7.036V6.772H9.6V7.947H9.64a2.818,2.818,0,0,1,2.536-1.392c2.71,0,3.211,1.783,3.211,4.1v4.73ZM4.016,5.593A1.553,1.553,0,1,1,5.569,4.039,1.552,1.552,0,0,1,4.016,5.593Zm1.341,9.8H2.675V6.772H5.357ZM16.723,0H1.333A1.317,1.317,0,0,0,0,1.3V16.758a1.316,1.316,0,0,0,1.333,1.3H16.721a1.321,1.321,0,0,0,1.338-1.3V1.3A1.322,1.322,0,0,0,16.721,0Z",
    fill: "#040227"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleLinkedin);
export default __webpack_public_path__ + "static/media/simple-linkedin.b9d01eeed378592eaf8bb043d71d3509.svg";
export { ForwardRef as ReactComponent };